export default "__VITE_ASSET__90709a00__"